export default __webpack_public_path__ + "static/media/Hands_Yellow.cf345a70.png";